<template>
  <div class="configurator__form">
    <div class="configurator__form-title">Ввести контактные данные и отправить заказ</div>
    <form @submit.prevent="debounce(validate)" class="form">
      <div class="form__inputs">
        <div class="custom-input">
          <input @input="this.reset" v-model="name" autocomplete="off" class="custom-input__input" type="text" placeholder="Введите ФИО" v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 4)}">
          <span v-if="errors.some(er => er.code === 4)" class="custom-input__error"></span>
          <label class="custom-input__label">ФИО*</label>
        </div>
        <div class="custom-input">
          <input @input="this.reset" @paste.prevent="removeFirstDigit" v-model="phone" autocomplete="off" class="custom-input__input" type="text" placeholder="Введите Телефон" inputmode="numeric" v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 1)}" data-mask-phone>
          <span v-if="errors.some(er => er.code === 1)" class="custom-input__error"></span>
          <label class="custom-input__label">Телефон*</label>
        </div>
        <div class="custom-input">
          <input @input="this.reset" v-model="email" autocomplete="off" class="custom-input__input" type="text" placeholder="Введите E-mail" v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 5)}">
          <span v-if="errors.some(er => er.code === 5)" class="custom-input__error"></span>
          <label class="custom-input__label">E-mail*</label>
        </div>
      </div>
      <div style="display: none">
        <vue-recaptcha ref="recaptcha" size="invisible" :sitekey="this.site_key" @verify="sendData" @expired="onCaptchaExpired"/>
      </div>
      <div class="form__submit">
        <input class="btn btn--mini" type="submit" value="Отправить"/>
        <div class="form__submit-text">Нажимая кнопку, Вы даете информированное согласие<br> на
          <a target="_blanc" :href="modulePolicy.file_src">обработку своих персональных данных</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import recaptcha  from "@/components/mixins/recaptcha";
import errors     from "@/components/mixins/errors";
import tools      from "@/components/mixins/tools";
import {mapState} from "vuex";
import { reachGoal as ymReachGoal } from "@/modules/metrika";

export default {
  name  : "ConfiguratorForm",
  props : {
    name_prop  : {
      type     : String,
      required : false,
      default  : ""
    },
    phone_prop : {
      type     : String,
      required : false,
      default  : ""
    },
    email_prop : {
      type     : String,
      required : false,
      default  : ""
    }
  },
  data()
  {
    return {
      name  : "",
      phone : "",
      email : "",
      steps : []
    };
  },
  mixins   : [recaptcha, errors, tools],
  computed : {
    ...mapState([
      "moduleConfigurator", "modulePolicy"
    ])
  },
  methods  : {
    sendData( recaptchaToken )
    {
      this.reset();
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("phone", this.phone);
      formData.append("email", this.email);
      formData.append("config", this.getConfig());
      formData.append("scheme", this.moduleConfigurator.scheme);
      formData.append("token", recaptchaToken);
      fetch("/api/configuration/", {
        method : "POST",
        body   : formData
      })
      .then(response => response.json())
      .then(async resp =>
      {
        if(resp.success !== true)
        {
          let errs = JSON.parse(resp.message);
          this.parse(errs);
        }
        else
        {
          ymReachGoal('configurator');
          window.toast.success("Спасибо за заказ!",
              "В ближайшее время с вами свяжутся наши специалисты.");
          this.debounce(this.clearAll);
        }
      });
    },
    getConfig()
    {
      let config = "";
      this.steps.forEach(el =>
      {
        config += el.SELECT_TITLE + ": " + el.SELECTED.name + ";";
      });
      return config;
    },
    clearAll()
    {
      localStorage.removeItem("steps");
      window.location.href = "/catalog/";
    }
  },
  created()
  {
    this.name  = this.name_prop ? this.name_prop : "";
    this.phone = this.phone_prop ? this.phone_prop : "";
    this.email = this.email_prop ? this.email_prop : "";
    if(localStorage.steps)
    {
      this.steps = JSON.parse(localStorage.steps);
    }
  }
};
</script>

<style scoped>

</style>
